import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { cloneDeep } from 'lodash-es'
import { CustomEventProps, IAction, ILucyAction, IRedirectAddOn, IRedirectUrl, IRedirectWidget } from './action-types';

export const ActionTypes = [
    { label: 'Open URL', value: 'open-url' },
    { label: 'Open Widget', value: 'open-widget' },
    { label: 'Execute Action', value: 'execute-action' },
    { label: 'Open Add-on', value: 'open-addon' },
    { label: 'Open Mobile Screen', value: 'open-mobile-ui' },
    { label: 'Trigger an Event', value: 'trigger-custom-event' },
];

export const ActionTypeIcons: { [type: string]: IconProp } = {
    'open-url': ['fas', 'link'],
    'open-widget': ['fas', 'window-maximize'],
    'execute-action': ['fas', 'bolt'],
    'open-addon': ['fas', 'puzzle-piece'],
    'open-mobile-ui': ['fas', 'mobile'],
    'trigger-custom-event': ['fas', 'broadcast-tower'],
};

export const DefaultAction: IAction = { type: 'open-url', redirectUrl: { url: 'about:blank' } }
export const DefaultRedirectUrl: IRedirectUrl = { url: 'about:blank', target: '_blank' }
export const DefaultRedirectAddon: IRedirectAddOn = { addon: null }
export const DefaultRedirectWidget: IRedirectWidget = { widget: null, params: {} }
export const DefaultLucyAction: ILucyAction = {
    modelName: '',
    action: '',
    params: {},
    dialogTitle: 'Execute Action',
    executionMsg: 'Executing action...',
    postExecution: {
        success: {
            msg: 'Executed successfully',
            buttonTitle: 'Done',
            action: { ...cloneDeep(DefaultAction) },
            reloadWidget: false
        },
        error: {
            msg: 'Execution failed',
            buttonTitle: 'Close',
            action: { ...cloneDeep(DefaultAction) },
            reloadWidget: false
        }
    }
}
export const DefaultCustomEvent: CustomEventProps = {
    eventId: '',
    params: {}
}
